/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum ActivationRedirectUrlOptions {
  ZORRO_UI = 'ZORRO_UI',
  ZORRO_OPS = 'ZORRO_OPS',
  ADD_EMPLOYER_GET_STARTED = 'ADD_EMPLOYER_GET_STARTED',
  CANCEL_INVITATION = 'CANCEL_INVITATION',
}
